<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :loading="loading"
      :totalData="totalMerchants"
      :refresh-table="getData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
    >     
    <template v-slot:top>
        <TableTopBroadcastList
          :selectedData="selectedData"
          :loading="loading"
          :isEdit="dataEdit !== null"
          @clearSelected="clearSelected"
          @broadcast="goToBroadcastForm"
          @refresh="getData"
        />
      </template>
      <template v-slot:custom="{ item }">
        <v-checkbox
          class="ma-0"
          dense
          hide-details="true"
          v-model="selectedData"
          :value="item"
        />
      </template>
      <template v-slot:body-prepend>
        <TableFilterBroadcastList :search.sync="search" :options.sync="options" v-on:getDataParent="getData" />
      </template>
    </TableView>

  </v-card>
</template>

<script>
import broadcastListMixin from '../../components/broadcast-management/broadcast-list/broadcastListMixin';
import { TableFilterBroadcastList, TableTopBroadcastList } from '../../components/broadcast-management/broadcast-list/components';

export default {
  mixins: [broadcastListMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableFilterBroadcastList,
    TableTopBroadcastList
  }
};
</script>

